export default __webpack_public_path__ + "static/media/virtual.9045ebe2.jpg";